import { render, staticRenderFns } from "./allocationOrderAudit.vue?vue&type=template&id=1d4e0ffc&scoped=true"
import script from "./allocationOrderAudit.vue?vue&type=script&lang=js"
export * from "./allocationOrderAudit.vue?vue&type=script&lang=js"
import style0 from "./allocationOrderAudit.vue?vue&type=style&index=0&id=1d4e0ffc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d4e0ffc",
  null
  
)

export default component.exports